import { UIHeading2, Button, Image, Body1 } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styles from './TabError.css';
import { fetchUserProfileThunk } from '../../../../../actions/userProfile';
import { currentOpenChatIDSelector } from '../../../../../selectors';

import errorImg from './assets/error.png';

export const TabError = () => {
  const chatId = useSelector(currentOpenChatIDSelector);

  const dispatch = useDispatch();

  const handleButtonClick = React.useCallback(() => {
    if (chatId) {
      dispatch(fetchUserProfileThunk(chatId));
    }
  }, [chatId, dispatch]);

  return (
    <div className={styles['wrapper']} data-testid="TabError">
      <Image src={errorImg} width={160} height={160} alt="" />

      <div className={styles['title']}>
        <UIHeading2>Что-то пошло не так</UIHeading2>
      </div>

      <div className={styles['text']}>
        <Body1 color="text-secondary-default">Обновите страницу или зайдите позже</Body1>
      </div>

      <div className={styles['button']}>
        <Button size="M" theme="main_primary" onClick={handleButtonClick}>
          Обновить
        </Button>
      </div>
    </div>
  );
};
